import { taxConstants } from '_constants';
import { userService } from '_services';
import { alertActions, userActions } from '_actions';
//import { history } from '_helpers';

export const taxActions = {
    getTicketTaxBreakdown,
    ticketTaxTermsQuery,
    acceptTicketTaxTerms
};

function getTicketTaxBreakdown(year, callback=null) {
    const params = {
        request: 'ticket_tax_breakdown',
      };
    if (year !== null) {
        params['for_year'] = year
    }
    return dispatch => {
        dispatch(request());
        userService.userRequest(params)
        .then(
            data => {
                if (data.success) {
                    console.log("Got ticketTaxBreakdown");
                    console.log(data)
                    dispatch(success(data));
                    if (callback !== null) {
                        callback(true, data.ticket_tax_breakdown)
                    }
                } else {
                    const msg = data.message ? data.message : "Unknown Server Error. Please try again"
                    dispatch(failure(msg.toString()));
                    dispatch(alertActions.error(msg.toString()));
                    if (callback) { callback(false, msg) }
                }
            },
            error => {
                if (error.status === 401) {
                    console.log("getTicketTaxBreakdown: fatal error")
                    dispatch(userActions.endSession(error))    
                }
            }
        )
    };
    
    function request()       { return { type: taxConstants.TICKET_TAX_BREAKDOWN_REQUEST} }
    function success(data)   { return { type: taxConstants.TICKET_TAX_BREAKDOWN_SUCCESS, data } }
    function failure(error)  { return { type: taxConstants.TICKET_TAX_BREAKDOWN_FAILURE, error } }
}


function ticketTaxTermsQuery(callback=null) {
    const params = {
        request: 'ticket_tax_terms_query',
      };

    return dispatch => {
        dispatch(request());
        userService.userRequest(params)
        .then(
            data => {
                if (data.success) {
                    console.log("Got ticketTaxTermsQuery");
                    console.log(data)
                    dispatch(success(data));
                    if (callback !== null) {
                        callback(true, data)
                    }
                } else {
                    const msg = data.message ? data.message : "Unknown Server Error. Please try again"
                    dispatch(failure(msg.toString()));
                    dispatch(alertActions.error(msg.toString()));
                    if (callback) { callback(false, msg) }
                }
            },
            error => {
                if (error.status === 401) {
                    console.log("ticketTaxTermsQuery: fatal error")
                    dispatch(userActions.endSession(error))    
                }
            }
        )
    };
    
    function request()       { return { type: taxConstants.TICKET_TAX_TERMS_QUERY_REQUEST} }
    function success(data)   { return { type: taxConstants.TICKET_TAX_TERMS_QUERY_SUCCESS, data } }
    function failure(error)  { return { type: taxConstants.TICKET_TAX_TERMS_QUERY_FAILURE, error } }
}

function acceptTicketTaxTerms(version, callback=null) {
    const params = {
        request: 'ticket_tax_terms_accepted',
      };
    params['version'] = version

    return dispatch => {
        dispatch(request());
        userService.userRequest(params)
        .then(
            data => {
                if (data.success) {
                    console.log("Got acceptTicketTaxTermsQuery");
                    console.log(data)
                    dispatch(success(data));
                    if (callback !== null) {
                        callback(true, data)
                    }
                } else {
                    const msg = data.message ? data.message : "Unknown Server Error. Please try again"
                    dispatch(failure(msg.toString()));
                    dispatch(alertActions.error(msg.toString()));
                    if (callback) { callback(false, msg) }
                }
            },
            error => {
                if (error.status === 401) {
                    console.log("acceptTicketTaxTermsQuery: fatal error")
                    dispatch(userActions.endSession(error))    
                }
            }
        )
    };
    
    function request()       { return { type: taxConstants.TICKET_TAX_TERMS_ACCEPTED_REQUEST} }
    function success(data)   { return { type: taxConstants.TICKET_TAX_TERMS_ACCEPTED_SUCCESS, data } }
    function failure(error)  { return { type: taxConstants.TICKET_TAX_TERMS_ACCEPTED_FAILURE, error } }
}



